import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { LEGAL_DOCS } from '../../data/legal';

const FooterBottomBar = () => {
  const { t, language } = useLanguage();

  return (
    <div className="pt-8 border-t border-white/10">
      <div className="flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-gray-400 text-sm">
          © 2026 MRK Digital. {t.footer?.rights}
        </p>
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm">
          {LEGAL_DOCS.map((doc) => (
            <Link
              key={doc.key}
              to={doc.path}
              data-testid={`footer-legal-${doc.key}`}
              className="text-gray-400 hover:text-orange-400 transition-colors"
            >
              {doc.label[language]}
            </Link>
          ))}
          <button data-testid="footer-terms-btn" className="text-gray-400 hover:text-orange-400 transition-colors">
            {t.footer?.terms}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FooterBottomBar;
